<template>
  <div class="quotes-contain"  v-loading="loading">
    <bCardHeader :param="param" :buttons="buttons"></bCardHeader>
    <component
    :is="currentComponent"
    :domestic="domestic"
    :recordsData="recordsData"
    :submitbtnLoading="submitbtnLoading"
    :terms="terms"
    :code="code"
    />
  </div>
</template>

<script>
import applyCardRecords from './components/applyCardRecords'
// import quotesApplyForm from './components/quotesApplyForm'
// import quotesApplyTerms from './components/quotesApplyTerms'
import complete from '../fund-transfer/info-dialog.vue'
import { mapGetters } from 'vuex'
import moment from 'moment'
import tradeRequest from '@/api/v2/trade.js'
export default {
  components: { applyCardRecords },
  computed: {
    ...mapGetters(['getAccountInfo', 'getClientProfile']),
    terms () {
      return this.$t('quotes.terms')[this.code] || this.$t('quotes.terms')['0']
    }
  },
  data () {
    return {
      title: '行情',
      currentComponent: 'applyCardRecords',
      domestic: true,
      applyForm: {
        applyContentType: '',
        applyCurrency: '',
        applyPrice: '',
        personalInfoDeclaration: '',
        agreement: '',
        updateClientInfo: {}
      },
      recordsData: [],
      buttons: [],
      param: {
        title: 'quotes',
        links: [
          { title: 'home' },
          { title: 'my_account' },
          { title: 'quotes' }
        ]
      },
      submitbtnLoading: false,
      loading: false,
      dialogParams: {
        IsCodeShow: false,
        closeModal: false,
        orderId: '',
        showClose: false, // 申请码关闭小图标
        contiune: true, // 申请码继续按钮
        componentDialog: complete // 申请码弹窗内容
      },
      code: ''
    }
  },
  mounted () {
    this.getQuotesApplyListHandle()
  },
  methods: {
    async getQuotesApplyListHandle () {
      const res = await tradeRequest.getQuoteServiceRecord()
        let data = res.data || []
        let recordsData = data.map(item => {
          let obj = {
            orderId: item.orderId,
            status: item.status,
            applyType: item.code,
            quotePeriod: item.quotePeriod,
            applyContentType: item.code,
            unit: item.unit ? item.unit : '/月',
            childList: {
              applyService: `${this.$t('quotes.' + item.actionType)} ${item.name}`,
              fee: `${item.currency} ${item.price}${this.$t('quotes.unit')}`,
              updatedTime: moment(item.createdDate).format('YYYY-MM-DD HH:mm:ss')
            }
          }
          if (obj.status === 'REJECT') {
            Object.assign(obj.childList, { remark: item.remark })
          }
          return obj
        })
        this.recordsData = recordsData || []
        this.loading = false
    },
    closeChange () {
      this.$message.success('申请成功')
    },
    async refresh () {
      await this.getQuotesApplyListHandle()
      this.currentComponent = 'applyCardRecords'
    }
  }
}
</script>
<style lang="scss">
.apply-form{
  .md-field{
    padding: 0 0.2rem 0 0.4rem;
    background: none;
    margin-bottom: 60px;
  }
  .md-agreement-icon{
    margin: auto 0 auto -50px !important;
  }
}

</style>
